import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { Container, CssBaseline, ThemeProvider } from '@material-ui/core';

import appTheme from './theme';
import { AppRouter } from './routes';

import { keycloak, keycloakConfig } from './keycloak';

import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

const App: React.FC = () => {
  const eventLogger = (event: unknown, error: unknown) => {
    console.log('onKeycloakEvent', event, error);
  };

  const tokenLogger = (tokens: unknown) => {
    console.log('onKeycloakTokens', tokens);
  };

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onEvent={eventLogger}
      onTokens={tokenLogger}
      initOptions={keycloakConfig}
    >
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <BrowserRouter>
          <Header />
          <Navbar />
          <Container>
            <AppRouter />
          </Container>
          {/* <Footer /> */}
        </BrowserRouter>
      </ThemeProvider>
    </ReactKeycloakProvider>
  );
};

export default App;
